import {z} from "zod"
import {frequencySchema} from "@indebted/payment-arrangement/Slider/Frequency"

import {getJson} from "../http"

const PaymentArrangementStatusSchema = z.strictObject({
	InstalmentAmountValue: z.number(),
	InstalmentAmountCurrency: z.string(),
	FrequencyValue: frequencySchema,
	StartDateValue: z.string(),
	EndDateValue: z.string(),
	ClientName: z.string(),
	CustomerName: z.string(),
})

export type PaymentArrangementStatus = z.infer<typeof PaymentArrangementStatusSchema>

export async function getStatusPage(paymentArrangementID: string, status: string): Promise<PaymentArrangementStatus> {
	const data = await getJson(
		`/app/payment-arrangements/${paymentArrangementID}/status/${status}`,
		PaymentArrangementStatusSchema,
	)
	return data
}
